import { Flex } from 'antd';
import { FC } from 'react';
import type { Study } from '@/models/study';
import { Tag } from '@/shared/ui/Tag';

interface Props {
  study: Study;
  compact?: boolean;
}

/**
 * Worklist tags column: the latest report's tags, AI ones marked with ✦.
 * Read only. Tags are edited on the report in the Reader.
 */
const StudyTagsCell: FC<Props> = ({ study, compact = false }) => {
  if (!study.tags || study.tags.length === 0) return <>—</>;

  return (
    <Flex gap={4} wrap>
      {study.tags.map((tag) => (
        <Tag
          key={tag}
          value={tag}
          compact={compact}
          ai={study.aiTags?.includes(tag)}
        />
      ))}
    </Flex>
  );
};

export default StudyTagsCell;
